// 是否是 B 端
export const IsClientTypeB = () => {
  const { appName } = Mach.env || {};
  return ['SailorPartner', 'SailorMerchant'].includes(appName);
};

// 获取 region locale cityId
export const getRegionLocal = () => {
  try {
    const SLMPI18N = Mach.requireModule('Intl');
    const { locale = 'en' } = SLMPI18N.getCurrentLocaleInfo() || {};
    // 商家端的region和locale不是通过定位拿到的，而是传过来的
    // todo-why:重要，商家端打开H5时候，region和locale获取方式还和C端一样吗？
    if (IsClientTypeB()) {
      const { region, cityId } = Mach.env.schemeParams || {};
      console.log('-region,cityId-', region, cityId);
      return { region, locale, cityId };
    } else {
      const SLCompass = Mach.requireModule('SLCompass');
      const { region, cityId } = SLCompass.getCompassInfo() || {};
      return { region, locale, cityId };
    }
  } catch (error) {
    // 异常上报
    return { region: '', locale: '', cityId: '' };
  }
};
